import { useSelectQuestion } from '~teacher/components/QuizQuestion';

interface UseSelectHasQuestionMediaParams {
  questionId: string;
}

export function useSelectHasQuestionMedia({
  questionId,
}: UseSelectHasQuestionMediaParams) {
  const { questionImage, questionVideo } = useSelectQuestion({
    questionId: questionId,
  });

  return !!questionImage?.url || !!questionVideo?.url;
}
